export const educationData = [
    {
        id: 1,
        institution: 'AlmaBetter Institute',
        course: 'Full Stack Web Development',
        startYear: '2022',
        endYear: '2023'
    },
    {
        id: 2,
        institution: 'Sri Ramakrishna Collage of Arts & Science',
        course: 'Bachelor of Business Administration with Computer Application',
        startYear: '2020',
        endYear: '2023'
    },
    {
        id: 3,
        institution: 'Institute of Cost Accountants of India',
        course: 'Foundation Course',
        startYear: '2019',
        endYear: '2020'
    },
    {
        id: 4,
        institution: 'Akshaya Academy Matriculation Higher Secondary School',
        course: 'Higher Secondary',
        startYear: '2017',
        endYear: '2019'
    },
]